import {connect} from '@modifi/redux'
import {aInitializeUser} from '@modifi/plugin-trade'

import Layout from './Layout'

const mapStateToProps = null

const mapDispatchToProps = {
  fetchUser: aInitializeUser,
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
